import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utilitário exigido pelos componentes do shadcn/ui (aliases.utils em
 * components.json). Combina classes condicionais e resolve conflitos do
 * Tailwind — a última classe vence.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
